import axios from 'axios';
import type { CamelCasedPropertiesDeep } from 'type-fest';

import { mapResponseErrorToMessage } from '@hotjar/webapp/domains/common/api';
import { keysToSnakeCase } from '@hotjar/webapp/lib/convert-string';
import type { OwnedAccountDTO } from '@hotjar/account';
import type { insightsSchema } from '@hotjar/insights-api-types';

type Operation = Required<insightsSchema.operations['putAccountCompanyDetails']>;
type UpdateCompanyDetailsCall = {
  UrlParams: Operation['parameters']['path'];
  RequestBody: Operation['requestBody']['content']['application/json'];
  ResponseBody: Operation['responses'][200 | 401 | 403]['content']['application/json'];
};
const API_ROOT = '/api/v1/accounts/';

export type Account = Pick<OwnedAccountDTO, 'id' | 'billing_cycle'>;

export type UpdateCompanyDetails = {
  account: Account;
} & CamelCasedPropertiesDeep<UpdateCompanyDetailsCall['RequestBody']>;

export async function updateCompanyDetails({
  account,
  ...requestPayload
}: UpdateCompanyDetails): Promise<UpdateCompanyDetailsCall['ResponseBody']> {
  const response = await axios.put<UpdateCompanyDetailsCall['ResponseBody']>(
    `${API_ROOT}${account.id}/company/details`,
    keysToSnakeCase(requestPayload),
  );

  if ('success' in response.data && !response.data.success) {
    // @ts-expect-error response type of error property shouldn't be unknown in the schema,
    //  needs to be fixed on Insights side
    throw new Error(mapResponseErrorToMessage(response.data.error));
  }

  return response.data;
}
